module.exports = __webpack_public_path__ + "static/media/17_tn.e92fcb5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/17_tn.jpg
// module id = 231
// module chunks = 0